module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-268.6f3e477.woff2";